import $ from "jQuery";
import Cookies from "js-cookie";

const $window = $(window);

function resizeHeader() {
  const cookie_welcome = Cookies.get("cookie_welcome");

  let distanceToTop = $window.scrollTop();
  if (distanceToTop > 0) {
    $(".header__wrapper").addClass("flatter");

    if (cookie_welcome === undefined) {
      $(".header__signpost").css(
        "margin-top",
        $(".header__signpost").outerHeight() * -1 + "px"
      );
      $(".content").css("padding-top", "");
      $(".title__links").css("transform", "");
    }
  } else {
    $(".header__wrapper").removeClass("flatter");

    if (cookie_welcome === undefined) {
      $(".header__signpost").css("display", "flex");
      $(".header__signpost").css("margin-top", "");
      $(".content").css(
        "padding-top",
        $(".header__signpost").outerHeight() + "px"
      );
      $(".title__links").css(
        "transform",
        `translateY(${$(".header__signpost").outerHeight() + "px"})`
      );
    }
  }
}

$(function () {
  resizeHeader();
  $window.on("scroll resize", resizeHeader);

  $(".header__signpost-close").on("click", function () {
    Cookies.set("cookie_welcome", "hide");

    $(".header__signpost").css(
      "margin-top",
      $(".header__signpost").outerHeight() * -1 + "px"
    );
    $(".content").css("padding-top", "");
    $(".title__links").css("transform", "");
  });
});
